import type { FC } from 'react';

import { Typography } from '@/design-system';
import { colors } from '@/design-system/colors';

import {
  CarouselCardDeltaChip,
  CarouselCardHeader,
  CarouselCardValueRow,
} from './carousel-card.styled';
import type { CardProps } from './common';

type Props = Pick<CardProps, 'title' | 'value' | 'delta'>;

export const CarouselCardTitle: FC<Props> = ({ title, value, delta }) => (
  <CarouselCardHeader>
    <Typography variant="body3" color={colors.text.secondary}>
      {title}
    </Typography>

    <CarouselCardValueRow>
      <Typography variant="h4">{value}</Typography>

      {delta ? (
        <CarouselCardDeltaChip>
          <Typography variant="body4" fontWeight={500} color={colors.brand.text}>
            {delta}
          </Typography>
        </CarouselCardDeltaChip>
      ) : null}
    </CarouselCardValueRow>
  </CarouselCardHeader>
);
